import Menu from '@Src/_basic/icons/Menu';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MonthlyReport from './components/MonthlyReport';
import TestRecordSheet from './components/Record';
import SieveAnalysisReport from './components/SieveReport';

export default function ViewReportMenu() {
  const { t: i18T } = useTranslation();

  return (
    <>
      <Stack alignItems="center" justifyContent="flex-start" flexDirection="row" sx={{ px: 1, color: 'white' }}>
        <Stack alignItems="center" justifyContent="center" sx={{ width: '40px' }}>
          <Menu />
        </Stack>
        <Typography sx={{ fontSize: 24, fontWeight: 900 }}>{i18T('VIEW.SIDE_MENU.TITLE')}</Typography>
      </Stack>
      <TestRecordSheet />
      <SieveAnalysisReport />
      <MonthlyReport />
    </>
  );
}
